import { del, get, post, patch } from "./api_helper";
import * as url from "./jiraya_url";

export const getEventImages = (config) => get(url.GET_EVENT_IMAGES, config);

//// public apis
export const postRequest = (data) => post(url.POST_REQUEST, data);
export const searchEvent = (config) => get(url.SEARCH_EVENT, config);
export const getPassKey = (config) => get(url.GET_PASS_KEY, config);
export const getOpenEvent = (config) => get(url.GET_EVENT_OPEN, config);
export const getOpenEventImages = (config) =>
  get(url.GET_EVENT_IMAGES_OPEN, config);
export const getOpenCollectionList = (config) =>
  get(url.GET_COLLECTION_LIST_OPEN, config);
export const getPinCheck = (config) => get(url.GET_PIN_CHECK, config);
export const getAccessKeyCheck = (config) =>
  get(url.GET_ACCESS_KEY_CHECK, config);
export const getOpenPortfolio = (config) => get(url.GET_OPEN_PORTFOLIO, config);
export const getOpenPortfolioEventImages = (config) =>
  get(url.GET_OPEN_PORTFOLIO_EVENT_IMAGES, config);
export const downloadOpenImages = (config) =>
  get(url.GET_OPEN_DOWNLOAD_IMAGE, config);

export const startOpenDownloadJob = (config) =>
  get(url.GET_OPEN_START_DOWNLOAD_JOB, config);

export const getOpenDownloadJobStatus = (config) =>
  get(url.GET_OPEN_DOWNLOAD_JOB_STATUS, config);

export const getOpenDownloadStats = (config) =>
  get(url.GET_OPEN_DOWNLOAD_STATS, config);

export const getOpenDownloadImageList = (config) =>
  get(url.GET_OPEN_DOWNLOAD_IMAGE_LIST, config);
export const getOpenImageLike = (config) =>
  get(url.GET_OPEN_IMAGE_LIKES, config);
export const getCommentImageList = (config) =>
  get(url.GET_OPEN_IMAGE_COMMENTS, config);
export const postOpenImageComment = (data) =>
  post(url.POST_OPEN_IMAGE_COMMENT, data);

export const getOpenImageCommentById = (config) =>
  get(url.GET_OPEN_COMMENT_BY_ID, config);

export const postOpenImageLike = (data) =>
  post(url.POST_OPEN_IMAGE_LIKES, data);

export const postOpenInquiry = (data) => post(url.POST_OPEN_INQUIRY, data);

export const postOpenActivity = (data) => post(url.POST_OPEN_ACTIVITY, data);

export const deleteOpenImageLike = (config) =>
  del(url.DELETE_OPEN_IMAGE_LIKES, config);
export const getOpenDownloadLinks = (config) =>
  get(url.GET_OPEN_DOWNLOAD_LINKS, config);
export const getOpenDownloadImageWithWM = (data) =>
  post(url.POST_OPEN_DOWNLOAD_IMAGE_WITH_WM, data);
export const getOpenUserLocation = () => get(url.GET_OPEN_USER_LOCATION);
export const getOpenPeople = (config) => get(url.GET_OPEN_PEOPLE, config);

// portfolio_event

export const getPortfolioEvent = (config) =>
  get(url.GET_PORTFOLIO_EVENT, config);

//for public gallery testing
export const patchCollectionToPortfolio = (data, config) =>
  patch(url.PATCH_COLLECTION_TO_PORTFOLIO, data, config);

export const getEvent = (config) => get(url.GET_EVENT_IMAGES_OPEN, config);

export const getCollectionList = (config) =>
  get(url.GET_COLLECTION_LIST, config);

export const getEventList = (config) => get(url.GET_EVENT_LIST, config);

export const getPublicGalleryEventList = (config) =>
  get(url.GET_PUBLIC_EVENT_GALLERY, config);

export const getPublicGalleryEventBranding = (config) =>
  get(url.GET_PUBLIC_EVENT_BRANDING, config);

export const getPublicEventCategoryList = (config) =>
  get(url.GET_PUBLIC_EVENT_CATEGORY_LIST, config);

export const getOneQRTheme = (config) => get(url.GET_ONEQR_THEME, config);

export const getOpenSponsorsList = (config) =>
  get(url.GET_OPEN_SPONSORS_LIST, config);
export const getOrgEventList = (config) => get(url.GET_ORG_EVENT_LIST, config);

// advocacy posters
export const getLinkedinSigninUrl = (config) =>
  get(url.GET_LINKEDIN_SIGNIN_URL, config);
export const postLinkedinPost = (data) => post(url.POST_LINKEDIN_POST, data);
export const postLinkedinAuthcode = (data, config) =>
  post(url.POST_LINKEDIN_AUTHCODE, data, config);
export const getPostersList = (config) => get(url.GET_POSTERS_LIST, config);
export const getLinkedinProfile = (config) =>
  get(url.GET_LINKEDIN_PROFILE, config);
export const patchLinkedinPosterInfo = (data) =>
  patch(url.PATCH_LINKEDIN_POSTER_INFO, data);

// guest user
export const patchGuestUserProfile = (data) =>
  patch(url.PATCH_GUEST_USER_PROFILE, data);
export const getUploadedImageList = (config) =>
  get(url.GET_UPLOADED_IMAGE_LIST, config);
export const deleteGuestUploadedImage = (data) =>
  del(url.DELETE_GUEST_UPLOADED_IMAGE, data);
export const getGuestUser = (config) => get(url.GET_GUEST_USER, config);
export const postFCMToken = (config) => post(url.POST_FIREBASE_TOKEN, config);

// league
export const getLeagueTeams = (config) => get(url.GET_LEAGUE_TEAMS, config);
export const getTeamPlayers = (config) => get(url.GET_TEAM_PLAYERS, config);

//sponsorIq
export const getClipQueryCollectionData = (config) =>
  get(url.GET_CLIP_QUERY_COLLECTION_DATA, config);

//photo selling
export const postBuyImage = (data) => post(url.POST_BUY_IMAGE, data);
export const getCartItems = (config) => get(url.GET_CART_ITEMS, config);
export const patchCartItemsList = (data) =>
  patch(url.PATCH_CART_ITEMS_LIST, data);
export const deleteCartItemsList = (data) =>
  del(url.DELETE_CART_ITEMS_LIST, data);
export const getBoughtImageList = (config) =>
  get(url.GET_BOUGHT_IMAGE_LIST, config);
export const postReelLike = (data) => post(url.POST_REEL_LIKE, data);
export const getReelLikeList = (config) => get(url.GET_REEL_LIKE_LIST, config);
export const getReelByID = (config) => get(url.GET_REEL_BY_ID, config);
export const deleteReelLike = (config) => del(url.DELETE_REEL_LIKE, config);

// face upload
export const postUploadFace = (data, config) => post(url.POST_UPLOAD_FACE, data, config);
export const postReelFeedback = (data) => post(url.POST_REEL_FEEDBACK, data);
